/* ============================================================================
   Mon Chou — Product personalizer tweaks (added 2026-06-09)

   1) Emoji / symbol picker: show the glyphs directly on the beige gradient
      instead of inside individual white boxes with a grey border. The Zepto
      Product Personalizer renders each symbol as an unclassed <span> inside
      .key_layout with a white background + 1px #ddd border (from adev.css);
      this makes each cell transparent with no border so the emojis sit
      straight on the .key_layout beige gradient. The ".p_space" key (the
      return / submit button) is intentionally left looking like a button.

   2) Font smiley: show the SAME animated smiley emoji-picker icon for the
      "Elegant" engraving font as the app already shows for "Moderne". For
      Moderne the app injects an animated <svg> smiley into .key_layout_sub;
      for Elegant it renders a near-invisible keyboard glyph instead. Whenever
      .key_layout_sub has no <svg>, we drop in an identical animated smiley
      (matching grey #9b9b9b). The toggle keeps working because the click
      handler lives on .key_layout_sub itself.
   ========================================================================== */
(function () {
  if (window.__mcPersonalizerTweaks) return;
  window.__mcPersonalizerTweaks = true;

  /* 1) Emoji cells on the beige gradient (inject a <style> once) */
  var css =
    '.product-personalizer .key_layout > span:not(.p_space){' +
      'background:transparent !important;background-color:transparent !important;' +
      'border:1px solid transparent !important;box-shadow:none !important;' +
      'border-radius:8px !important;}' +
    '.product-personalizer .key_layout > span:not(.p_space):hover{' +
      'background:rgba(168,140,100,0.16) !important;border-color:transparent !important;}';
  var st = document.createElement('style');
  st.setAttribute('data-mc', 'personalizer-tweaks');
  st.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(st);

  /* 2) Elegant-font animated smiley */
  var SMILEY = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"><path stroke-dasharray="60" stroke-dashoffset="60" d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.5s" values="60;0"/></path><path stroke-dasharray="14" stroke-dashoffset="14" d="M8 14C8.5 15.5 9.79086 17 12 17C14.2091 17 15.5 15.5 16 14"><animate fill="freeze" attributeName="stroke-dashoffset" begin="1s" dur="0.2s" values="14;0"/></path></g><g fill="currentColor" fill-opacity="0"><ellipse cx="9" cy="9.5" rx="1" ry="1.5"><animate fill="freeze" attributeName="fill-opacity" begin="0.6s" dur="0.2s" values="0;1"/></ellipse><ellipse cx="15" cy="9.5" rx="1" ry="1.5"><animate fill="freeze" attributeName="fill-opacity" begin="0.8s" dur="0.2s" values="0;1"/></ellipse></g></svg>';

  function inject(sub) {
    if (!sub || sub.querySelector('svg')) return; // Moderne already shows the smiley
    sub.innerHTML = SMILEY;
    var svg = sub.querySelector('svg');
    if (svg) { svg.style.color = '#9b9b9b'; svg.style.pointerEvents = 'none'; }
  }
  function run() {
    var list = document.querySelectorAll('.product-personalizer .key_layout_sub');
    for (var i = 0; i < list.length; i++) inject(list[i]);
  }
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; run(); });
  }
  function start() {
    run();
    try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    setInterval(run, 1000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* 3) Octagon m. zirkonkant (product 10216298348885, added 2026-10-07): centre the
      engraving preview by its ink, like the Cirkel products, so every text sits in
      the middle of the octagon face. Registers the product in the personalizer's
      TUNE.fit (window.__mcTune) once mc-personalizer.js has loaded. */
(function addOctagonFit(tries) {
  var T = window.__mcTune;
  if (T && T.fit) { if (!T.fit['10216298348885']) T.fit['10216298348885'] = { vInk: 1 }; return; }
  if (tries < 400) setTimeout(function () { addOctagonFit(tries + 1); }, 50);
})(0);

/* 4) Rund m. zirkonkant (product 10216281768277, added 2026-10-09): centre the
      engraving preview by its ink on the new round face, like the Octagon. */
(function addRoundZirkonFit(tries) {
  var T = window.__mcTune;
  if (T && T.fit) { if (!T.fit['10216281768277']) T.fit['10216281768277'] = { vInk: 1 }; return; }
  if (tries < 400) setTimeout(function () { addRoundZirkonFit(tries + 1); }, 50);
})(0);

/* 5) Show the blank preview as soon as the customer taps the engraving field
      (added 2026-10-10). Before, the preview blank (the photo without engraving)
      only appeared after the first typed character, so the main image's demo
      engraving stayed visible while the customer started typing. On focus we set
      the personalizer's placementPicked flag (window.__mcState) and ask it to
      redraw, which paints the empty blank over the main image, ready for text. */
(function () {
  if (window.__mcBlankOnFocus) return;
  window.__mcBlankOnFocus = true;
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var field = t.closest('.mc-field');
    if (!field) return;
    var input = field.querySelector('.mc-text-input');
    var S = window.__mcState;
    if (!input || !S || S.placementPicked) return;
    S.placementPicked = true;
    try { input.dispatchEvent(new Event('input', { bubbles: true })); } catch (err) {}
  }, true);
})();
